import React from 'react';
import dynamic from 'next/dynamic';
import DOMPurify from 'isomorphic-dompurify';
import PropTypes from 'prop-types';
import Image from '../Image/Image';
import { mediaQueryHOC } from '../Mixture/View/exportComponent';
import Block from '../../adapters/helpers/Block';
import {
  Constants,
  miniContentBlockConstants,
} from '../../adapters/helpers/Constants';
const ResponsiveImage = dynamic(() =>
  import('../ResponsiveImage/ResponsiveImage')
);
import { toLower } from 'lodash';

const MiniContentBlock = (props) => {
  const { document, isSmall } = props;

  const className = document?.fields?.className;
  const anchorId = document?.fields?.anchorId;
  const desktopBannerImage = document?.fields?.desktopBannerImage;
  const mobileBannerImage = document?.fields?.mobileBannerImage;
  const eyebrow = document?.fields?.eyebrow;
  const headerText = document?.fields?.headerText;
  const subText = document?.fields?.subText;
  const secondSubText = document?.fields?.secondSubText;
  const disclaimer = document?.fields?.disclaimer;
  const bannerBackgroundColour = document?.fields?.bannerBackgroundColour;
  const textColour = document?.fields?.textColour;
  const headerTextStyle = document?.fields?.headerTextStyle;
  const subTextStyle = document?.fields?.subTextStyle;
  const secondSubTextStyle = document?.fields?.secondSubTextStyle;
  const bannerImagePosition = document?.fields?.bannerImagePosition;
  const bannerVideo = document?.fields?.bannerVideo;
  const videoThumbnail = document?.fields?.videoThumbnail;
  const ctaButton = document?.fields?.ctaButton;
  const ctaObject = ctaButton?.CTA;

  const textStyle = {
    color: textColour,
    textAlign: isSmall ? 'center' : 'left',
    width: '100%',
  };

  const getUpdatedStyles = (styleType) => {
    const styleObject = isSmall ? styleType?.mobile : styleType?.desktop;

    return {
      ...textStyle,
      ...styleObject,
    };
  };

  const renderImage = () => {
    return (
      <div className='ob-mini-content-image-container'>
        {bannerVideo ? (
          bannerVideo ? (
            <div>
              {new Block(bannerVideo).renderBlockFromDocument(bannerVideo)}{' '}
            </div>
          ) : (
            videoThumbnail && (
              <div className='ob-carousel-tab-content-conatiner-image'>
                <ResponsiveImage document={videoThumbnail}></ResponsiveImage>
              </div>
            )
          )
        ) : (
          <Image
            className={
              isSmall
                ? 'ob-mini-content-mobile-image'
                : 'ob-mini-content-dektop-image'
            }
            image={isSmall ? mobileBannerImage : desktopBannerImage}
            altText={
              isSmall
                ? mobileBannerImage?.fields?.alternateText
                : desktopBannerImage?.fields?.alternateText
            }
          />
        )}
      </div>
    );
  };

  const renderText = () => {
    return (
      <div
        className='ob-mini-content-text-area-wrapper'
        style={{ backgroundColor: bannerBackgroundColour }}
      >
        {eyebrow && (
          <p
            className='ob-mini-content-eyebrow'
            style={textStyle}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(eyebrow) }}
          />
        )}
        {headerText && (
          <h2
            className='ob-mini-content-header'
            style={getUpdatedStyles(headerTextStyle)}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(headerText) }}
          />
        )}
        {subText && (
          <p
            className='ob-mini-content-sub-text'
            style={getUpdatedStyles(subTextStyle)}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(subText) }}
          />
        )}
        {secondSubText && (
          <p
            className='ob-mini-content-sub-text'
            style={getUpdatedStyles(secondSubTextStyle)}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(secondSubText),
            }}
          />
        )}
        {ctaButton && ctaObject && (
          <a
            className='ob-button ob-mini-content-cta'
            style={{
              backgroundColor:
                toLower(ctaObject.ctaColor) ===
                miniContentBlockConstants.whiteCtaColorValue
                  ? miniContentBlockConstants.whiteCtaColor
                  : miniContentBlockConstants.blueCtaColor,
              color:
                toLower(ctaObject.ctaColor) ===
                miniContentBlockConstants.whiteCtaColorValue
                  ? miniContentBlockConstants.blueCtaColor
                  : miniContentBlockConstants.whiteCtaColor,
            }}
            target='_blank'
            rel='noopener noreferrer'
            href={`${ctaObject.ctaLink}`}
          >
            <span>{ctaObject.ctaLabel}</span>
          </a>
        )}
        {disclaimer && (
          <p
            className='ob-mini-content-disclaimer'
            style={textStyle}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(disclaimer) }}
          />
        )}
      </div>
    );
  };

  const renderMiniContentBlock = () => {
    return (
      <>
        {(bannerImagePosition === Constants.bannerImagePositionLeft ||
          bannerImagePosition === Constants.bannerImagePositionUp) &&
          renderImage()}
        {renderText()}
        {bannerImagePosition === Constants.bannerImagePositionRight &&
          renderImage()}
      </>
    );
  };

  return (
    <div
      className={`ob-mini-content-block ${className ? className : ''}`}
      id={anchorId}
      style={{ backgroundColor: bannerBackgroundColour }}
    >
      {!isSmall && renderMiniContentBlock()}
      {isSmall && (
        <>
          {renderImage()}
          {renderText()}
        </>
      )}
    </div>
  );
};

MiniContentBlock.propTypes = {
  document: PropTypes.object,
  isSmall: PropTypes.boolean,
};
export default mediaQueryHOC(MiniContentBlock);
